import { navigateToRoute, toggleIsInfoPaneExpanded } from 'redux_store';
import { PATIENT_TABLE_NAMES, ALL_ROUTES } from '@app/router';

/**
 * Navigate to the patient dashboard route corresponding to the pane's
 * current context, then collapse the pane after the route settles.
 *
 * Pulled out of `PatientPane` so the sticky footer in `InfoPane.jsx`
 * (shell) can invoke the same dispatch without duplicating the
 * branching logic.
 *
 * Mirrors the legacy `openPatientPage` from
 * `_legacy/components/InfoPane/Pages/PatientInfo/index.js`:
 *   - DS accounts viewing a child account's patient → dashboardDS route
 *   - else → dashboard route
 *   - tableName defaults to assessment tab
 *   - pane collapses 1 s after dispatch (gives the route a moment)
 */
export const openPatientDashboard = ({
  dispatch,
  context,
  patient,
  currentAccount,
  isDistributionSponsor,
  i18n,
}) => {
  if (!patient || !context) return;
  const isChild =
    context.accountUUID &&
    context.accountUUID !== currentAccount.uuid &&
    isDistributionSponsor;

  dispatch(
    navigateToRoute({
      route: {
        path: (isChild ? ALL_ROUTES.patient.dashboardDS : ALL_ROUTES.patient.dashboard).path,
        params: {
          currentAccountUuid: currentAccount.uuid,
          accountUuid: isChild ? context.accountUUID : null,
          patientUuid: context.patientUUID ?? context.uuid,
          tableName: PATIENT_TABLE_NAMES.overview,
        },
        title: `${i18n.titles.patientDashboard}: ${
          patient.patientFirstName ?? patient.firstName
        } ${patient.patientLastName ?? patient.lastName}`,
      },
    })
  );
  setTimeout(() => dispatch(toggleIsInfoPaneExpanded(false)), 1000);
};
